import React, { Component, PropTypes } from 'react';

import { getOneLineAddress } from 'components/Gbp/gbpHelper';
import { CREATE_LOCATION } from 'constants/gbp';
import LoadingIndicator from 'components/LoadingIndicator';

class GbpSearch extends Component {
  static propTypes = {
    handleOnSearchInitialLocation: PropTypes.func,
    handleSearchEnter: PropTypes.func,
    handleOnSearchTextChange: PropTypes.func,
    searchText: PropTypes.string,
    handleOnSearchLocation: PropTypes.func,
    selected: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    setSelectedSearchItem: PropTypes.func,
    brand: PropTypes.object,
    locations: PropTypes.object,
    isUserLocations: PropTypes.bool,
    fetchUserLocations: PropTypes.func,
    isSearchLoading: PropTypes.bool,
    isLoading: PropTypes.bool,
  };

  componentDidMount() {
    const { brand, locations, handleOnSearchInitialLocation, fetchUserLocations } = this.props;
    const brandName = brand.get('brandName');
    // Fetch My locations - loactions prop will pass either my locations or search locations

    if (brandName && locations.isEmpty()) {
      // Call GBP endpoint to search initial location
      handleOnSearchInitialLocation(brandName);
      fetchUserLocations();
    }
  }

  getAddress = (location) => {
    const storefrontAddress = location.get('location').get('storefrontAddress');
    if (!storefrontAddress) return '';
    return getOneLineAddress(storefrontAddress.get('addressLines'), storefrontAddress.get('locality'), storefrontAddress.get('regionCode'));
  }

  render() {
    const {
      locations,
      handleSearchEnter,
      handleOnSearchTextChange,
      searchText,
      handleOnSearchLocation,
      setSelectedSearchItem,
      selected,
      isUserLocations,
      isSearchLoading,
      isLoading,
    } = this.props;

    const searchItemClass = 'list-item-with-sub';
    const selectedSearchItemClass = searchItemClass.concat(' selected');
    const searchListClass = 'list-items-with-sub';
    const searchListNoDataClass = searchListClass.concat(' with-no-data');

    return (
      <div>
        {isLoading && !isUserLocations ? <div className={'loadmore'}><LoadingIndicator loading={isLoading} /></div> :
          <div className={'w-70'}>
            {isUserLocations ? null :
              <div className='searchbox-widget mb-11'>
                <input
                  type='search'
                  placeholder='Search by Location Name'
                  ref='skey'
                  onKeyUp={handleSearchEnter}
                  onChange={handleOnSearchTextChange}
                  value={searchText}
                />
                {/*<i className='material-icons md-24 clear-icon pointer' onClick={ this.onClear }>clear</i>*/}
                <i className='material-icons md-24 search-icon pointer' onClick={handleOnSearchLocation}>search</i>
              </div>
            }

            {/*add 'with-no-data' class to this div when no data scenario*/}
            {isSearchLoading ? <div className={'loadmore'}><LoadingIndicator loading={isSearchLoading} /></div> :
              <div className={locations.isEmpty() ? searchListNoDataClass : searchListClass}>
                {isUserLocations ? null :
                  <div
                    className={selected === CREATE_LOCATION ? selectedSearchItemClass : searchItemClass}
                    onClick={() => setSelectedSearchItem(CREATE_LOCATION)}
                  >
                    <div className={'list-item-title'}>{searchText}</div>
                    <div className={'list-item-sub'}>Create New Location '{searchText}'</div>
                  </div>
                }
                <div className={'list-item-separator'}> </div>
                {
                  locations.map(location => (
                    <div
                      className={typeof selected === 'object' && selected !== null && selected.get('name') === location.get('name') ? selectedSearchItemClass : searchItemClass}
                      key={location.get('name')}
                      onClick={() => setSelectedSearchItem(location)}
                    >
                      <div className={'list-item-title'}>{location.get('location') && location.get('location').get('title')}</div>
                      <div className={'list-item-sub'}>{this.getAddress(location)}</div>
                    </div>
                  ))
                }

                {/*below code only applicable when no data scenario*/
                  locations.isEmpty() ?
                    (<p className='mui--text-center no-data-text'>
                      No Location Available. Please refine your search!
                    </p>) : null
                }
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

export default GbpSearch;
